/* Tuan et al., Scientific Reports 8,10844 (2018), equations 7–11.
 * https://doi.org/10.1038/s41598-018-29244-6
 * Numerical adaptation: even modes 0..24, centred point excitation;
 * normalized response omits the common spatially constant coupling factor.
 * Model parameters are mechanical dimensionless values, not EEG frequencies.
 */
(() => {
  'use strict';
  function buildField(width,height,resolution,spec){
    const {ka,delta}=spec,q=(ka/Math.PI)**2,gamma=.16,scale=1.5;
    const order=13,cr=new Float64Array(order*order),ci=new Float64Array(order*order);
    for(let m=0;m<order;m++)for(let n=0;n<order;n++){
      const a=m*2,b=n*2,e=(1-delta)*a*a+(1+delta)*b*b;
      const real=e*e-q*q+gamma*gamma,imag=2*q*gamma;
      const coupling=Math.cos(a*Math.PI/2)*Math.cos(b*Math.PI/2),den=real*real+imag*imag;
      cr[m*order+n]=coupling*real/den;ci[m*order+n]=-coupling*imag/den;
    }
    const cx=new Float64Array(resolution*order),sx=new Float64Array(resolution*order);
    const cy=new Float64Array(resolution*order),sy=new Float64Array(resolution*order);
    for(let i=0;i<resolution;i++){
      const x=(i/(resolution-1)*width-width/2)/Math.PI*scale+.5;
      const y=(i/(resolution-1)*height-height/2)/Math.PI*scale+.5;
      for(let m=0;m<order;m++){
        const n=m*2;
        cx[i*order+m]=Math.cos(n*Math.PI*x);sx[i*order+m]=-n*scale*Math.sin(n*Math.PI*x);
        cy[i*order+m]=Math.cos(n*Math.PI*y);sy[i*order+m]=-n*scale*Math.sin(n*Math.PI*y);
      }
    }
    const field=new Float32Array(resolution*resolution*3);
    const tr=new Float64Array(order),ti=new Float64Array(order),yr=new Float64Array(order),yi=new Float64Array(order);
    let max=0;
    for(let row=0;row<resolution;row++){
      tr.fill(0);ti.fill(0);yr.fill(0);yi.fill(0);
      for(let m=0;m<order;m++)for(let n=0;n<order;n++){
        const c=m*order+n,j=row*order+n;
        tr[m]+=cr[c]*cy[j];ti[m]+=ci[c]*cy[j];yr[m]+=cr[c]*sy[j];yi[m]+=ci[c]*sy[j];
      }
      for(let col=0;col<resolution;col++){
        let r=0,im=0,rx=0,ix=0,ry=0,iy=0;
        for(let m=0;m<order;m++){
          const j=col*order+m;
          r+=cx[j]*tr[m];im+=cx[j]*ti[m];rx+=sx[j]*tr[m];ix+=sx[j]*ti[m];ry+=cx[j]*yr[m];iy+=cx[j]*yi[m];
        }
        const value=r*r+im*im,j=(row*resolution+col)*3;
        max=Math.max(max,value);field[j]=value;field[j+1]=2*(r*rx+im*ix);field[j+2]=2*(r*ry+im*iy);
      }
    }
    const factor=1/Math.max(max,1e-30);
    for(let i=0;i<field.length;i++)field[i]*=factor;
    return field;
  }
  self.DMModalStudy={buildField};
})();
